import { render } from "./StandardHeaderUserMenu.vue?vue&type=template&id=4962e5b2&scoped=true"
import script from "./StandardHeaderUserMenu.vue?vue&type=script&lang=js"
export * from "./StandardHeaderUserMenu.vue?vue&type=script&lang=js"

import "./StandardHeaderUserMenu.vue?vue&type=style&index=0&id=4962e5b2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4962e5b2"]])

export default __exports__